import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Link
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import getStyles from './styles';
import { useNavigate } from 'react-router-dom';

const TenDaysMVPReady = () => {
  const styles = getStyles();
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);

  const handleStartProject = () => {
    navigate('/contact');
  };

  return (
    <Box component="section" sx={styles.section}>
      {/* Animated background overlay */}
      <Box sx={styles.animatedBackground} />

      <Container maxWidth="xl" sx={styles.container}>
        <Box sx={styles.contentWrapper}>
          {/* Heading */}
          <Typography variant="h2" sx={styles.title}>
            Ready to Launch Your Website in 10 Days?
          </Typography>

          <Typography variant="h5" sx={styles.subtitle}>
            Join hundreds of satisfied clients who trusted us with their online
            presence
          </Typography>

          {/* Card */}
          <Box sx={styles.card}>
            {/* Terms Checkbox */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreed}
                  onChange={(e) => setAgreed(e.target.checked)}
                  sx={styles.checkbox}
                />
              }
              label={
                <Typography variant="body2" sx={styles.termsLabel}>
                  I confirm I have read and agree to the{' '}
                  <Link href="#terms" underline="hover" sx={styles.termsLink}>
                    10-Days Website Launch Terms & Conditions
                  </Link>
                </Typography>
              }
            />

            {/* CTA Button */}
            <Button
              variant="contained"
              color="secondary"
              size="large"
              fullWidth
              disabled={!agreed}
              endIcon={<ArrowForwardIcon sx={styles.arrowIcon} />}
              sx={styles.ctaButton}
              onClick={() => handleStartProject()}
            >
              Start My 10-Days Website Launch
            </Button>

            {/* Security Note */}
            <Typography variant="caption" sx={styles.securityNote}>
              🔒 Secure checkout • 💯 Money-back guarantee • ⚡ 48-hour delivery
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default TenDaysMVPReady;
